import { Injectable } from '@angular/core';
import { IPageVisibility } from '../../models/page.interface';
import { IntelligentKeyboardSection } from './intelligent-keyboard/intelligent-keyboard-section';
import { CommonService } from 'src/app/services/common/common.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
@Injectable({
	providedIn: 'root',
})
export class InputAccessoriesPage implements IPageVisibility {
	constructor(private intelligentKeyboardSection: IntelligentKeyboardSection,private commonService: CommonService,) {}

	public async isVisible(): Promise<boolean> {
		let machineFamily = this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineFamilyName,
			undefined
		);
		machineFamily = machineFamily.replace(/\s+/g, '');
		const machineType = this.commonService.getLocalStorageValue(LocalStorageKey.MachineType);

		if(machineType === 1 && machineFamily === '10w'){
			return false;
		}
		return this.intelligentKeyboardSection.isVisible();
	}
}
